export const DATA_HOVER = 'datahover';
export const DATA_OUT = 'dataout';
export const MOUSE_MOVE = 'mousemove';
export const MOUSE_OUT = 'mouseout';
export const MOUSE_OVER = 'mouseover';
export const MOVE = 'move';
export const OUT = 'out';
export const RESIZE = 'resize';
export const TOUCH_END = 'touchend';
export const TOUCH_MOVE = 'touchmove';
export const TOUCH_START = 'touchstart';

export const getNamespaced = function (type, namespace) {
  if (!type) {
    return '';
  }
  if (!namespace) {
    return type;
  }
  return `${type}.${namespace}`;
};
